import { City, ContactFormDataReq, ContactFormdataRes, Developer, FetchProjectsParams, HomePageData, NearbyLocations, NewsletterDataReq, Project } from "@/data/types";

const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL

export async function fetchProjects(params: FetchProjectsParams = {}): Promise<Project[]> {
  const query = new URLSearchParams()

  if (params.city) query.append("city", params.city)
  if (params.propertyType) query.append("project_type", params.propertyType)
  if (params.priceFrom !== undefined) query.append("min_price", params.priceFrom.toString())
  if (params.priceTo !== undefined) query.append("max_price", params.priceTo.toString())
  if (params.sort) query.append("sort", params.sort)
  if (params.developer_id !== undefined) query.append("developer_id", params.developer_id.toString()) 
  if (params.status) query.append("status", params.status)

  const res = await fetch(`${BASE_URL}/api/projects?${query.toString()}`)
  if (!res.ok) throw new Error("Failed to fetch projects")
  const json = await res.json();
  return json.data.data
}

export async function getProject(slug: string): Promise<Project>  {
  const res = await fetch(`${BASE_URL}/api/projects/${slug}`, { cache: "no-store" });
  if (res.status === 404) return null as unknown as Project
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data
}

export async function getDevelopers(): Promise<Developer[]> {
  const res = await fetch(`${BASE_URL}/api/developers`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data.data
}

export async function fetchCities(): Promise<City[]> {
  const res = await fetch(`${BASE_URL}/api/cities`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data.data
}

export async function fetchNearbyLocations(slug: string): Promise<NearbyLocations> {
  const res = await fetch(`${BASE_URL}/api/projects/${slug}/nearby-locations?grouped=true`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data
}

export async function sendContactForm(data: ContactFormDataReq): Promise<ContactFormdataRes> {
  const res = await fetch(`${BASE_URL}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) throw new Error("Failed to send contact form");
  return res.json();
}


export async function fetchActivePaymentPlan(slug: string) {
  const res = await fetch(`${BASE_URL}/api/projects/${slug}/payment-plans/active`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data
}

export async function fetchProjectGallery(slug: string) {
  const res = await fetch(`${BASE_URL}/api/projects/${slug}/gallery`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data
}

export async function fetchHomePageData(): Promise<HomePageData> {
  const res = await fetch(`${BASE_URL}/api/homepage`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch project");
  const json = await res.json();
  return json.data
}

export async function subToNewsletter(data: NewsletterDataReq) {
  const res = await fetch(`${BASE_URL}/api/newsletter/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) throw new Error("Failed to subscribe to newsletter");
  return res.json();
}